/*@flow*/
import type { Element } from 'react';
import React from 'react';
import { AutocompleteApi } from 'lib/useAutocomplete';
import * as db from 'lib/db';

export default ({
  apiRef,
}: {
  apiRef: { current: AutocompleteApi | null },
}): Element<'select'> => {
  const api = apiRef.current;

  return (
    <select
      className="form-control-sm float-right border-0"
      defaultValue={db.read('country') || 'us'}
      data-testid="CountryDropdown"
      onChange={(el) => {
        const country = el.target.value;
        db.write('country', country);
        if (!api) return;
        api.setCountry(country);
      }}
      style={{ background: 'white' }}
    >
      <option value="us">US</option>
      <option value="ca">Canada</option>
      <option value="uk">UK</option>
    </select>
  );
};
